/* eslint-disable @typescript-eslint/no-explicit-any */
import App from './App';

import ErrorBoundary from 'ErrorBoundary';
import FallBackComponent from 'components/FallBackComponent';

//Boostrap Libs
import 'bootstrap/dist/js/bootstrap.bundle.min';

import './assets/css/bootstrap.min.css';
import './assets/css/bootstrap-icons.css';
import './assets/css/pcrf.css';
import './index.css';

//Redux
import {Provider} from 'react-redux';
import {createRoot} from 'react-dom/client';

import {persistor, store} from './store';
import {PersistGate} from 'redux-persist/integration/react';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement as any);

root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<ErrorBoundary fallBack={<FallBackComponent />}>
				<App />
			</ErrorBoundary>
		</PersistGate>
	</Provider>,
);
